import { render, staticRenderFns } from "./programTable.vue?vue&type=template&id=31b855b7&scoped=true"
import script from "./programTable.vue?vue&type=script&lang=js"
export * from "./programTable.vue?vue&type=script&lang=js"
import style0 from "./programTable.vue?vue&type=style&index=0&id=31b855b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b855b7",
  null
  
)

export default component.exports